<template>
  <div style="overflow: scroll">
    <div>this.model.percentage{{ this.model.percentage }}</div>
    <div @click="rotate()">旋转</div>
    <div @click="shrink(0.1)">+ {{ model.scale }}</div>
    <div @click="shrink(-0.1)">-</div>
    <div>
      x:<input type="range" step="0.01" max="2" v-model="model.x" />{{
        model.x
      }}
    </div>
    <div>
      y:<input type="range" step="0.01" max="2" v-model="model.y" />{{
        model.y
      }}
    </div>
    <div>lock <input type="checkbox" v-model="model.lock" /></div>
    <crop-item
      backgroundColor="red"
      ref="crop"
      :media="{}"
      :model="model"
    ></crop-item>
    <img style="zoom: 0.2" :src="src" />
  </div>
</template>

<script>
import { exportImage } from "../../../service/media";
import { imageLoad } from "../../../utils/media";
import CropItem from "../../../components/media/crop/CropItem";

export default {
  name: "MediaCropThumbnailsPage",
  components: { CropItem },
  data() {
    return {
      elCrop: null,
      image: null,
      src: "",
      cropParams: [],
      model: {
        url: "https://files.apphi.com/1108/posts/7c43b5c105dc84d665181face4d4e11d",
        // url: 'https://files.apphi.com/1108/posts/9a18def45f15434cde5543234057cd9a', // 特别高
        // url: 'https://files.apphi.com/1108/posts/5eaa260fd4a3e0d0a4e99637cae83309', // 特别宽
        // url: 'https://files.apphi.com/1108/posts/3a36042679f680335888043acf16cde0',
        x: 0,
        y: 0,
        image: null,
        rotate: 0, // 图片的旋转个监督
        scale: 1, // 图片的缩放比例
        filter: "valencia", // 添加的滤镜名称
        percentage: 0.8, // 裁切框比例(宽高比)
        lock: true, // 锁定
      },
      minScale: 1,
      maxScale: 5,
    };
  },
  watch: {
    model: {
      async handler(val) {
        await this.exportImg({ model: val });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 旋转
     */
    rotate() {
      this.$refs.crop.rotate();
    },
    /**
     * 缩小图片
     */
    shrink(num) {
      this.$refs.crop.shrink(num);
    },
    /**
     * 导出图片
     */
    async exportImg({ model }) {
      const resultImg = await exportImage({ model });
      this.src = resultImg.toDataURL("image/jpeg");
    },
  },
  async created() {
    let image = new Image();
    image.crossOrigin = "anonymous";
    image.src = `${this.model.url}?t=${new Date().getTime()}`;
    await imageLoad({ image });
    this.model.image = image;
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/theme";
</style>
